const comite_executivo = {
  pessoas: [
    {
      nome: 'Zeca Doherty',
      cargo: 'Superintendente-geral',
      descricao: '',
      imagem: 'comite1',
    },
    {
      nome: 'Ana Leoni',
      cargo: 'Superintendente de Educação e Informações Técnicas',
      descricao: '',
      imagem: 'comite3',
    },
    {
      nome: 'Eliana Marino',
      cargo: 'Gerente de Recursos Humanos',
      descricao: '',
      imagem: 'comite6',
    },
    {
      nome: 'Francisco Vidinha',
      cargo: 'Superintendente do Selic',
      descricao: '',
      imagem: 'comite5',
    },
    {
      nome: 'Guilherme Benaderet',
      cargo: 'Superintendente de Supervisão de Mercados',
      descricao: '',
      imagem: 'comite4',
    },
    {
      nome: 'Lina Yajima',
      cargo: 'Gerente de Tecnologia da Informação',
      descricao: '',
      imagem: 'comite10',
    },
    {
      nome: 'Marcelo Billi',
      cargo: 'Gerente de Comunicação e Marketing',
      descricao: '',
      imagem: 'comite7',
    },
    {
      nome: 'Patricia Herculano',
      cargo: 'Superintendente de Representação Institucional',
      descricao: '',
      imagem: 'comite2',
    },
    {
      nome: 'Soraya Alves',
      cargo: 'Gerente da Assessoria Jurídica',
      descricao: '',
      imagem: 'comite8',
    },
    {
      nome: 'Thiago Baptista',
      cargo: 'Gerente da Controladoria e Administração',
      descricao: '',
      imagem: 'comite9',
    }
    
  ],
};

export { comite_executivo };
